<section class="builder-header-container">
    <div class="builder-header-navigation-container" [class.cover]="showCover" [class.popupMode]="popupMode">
    <div class="navigation-action-container"
         [class.with-animation]="_builderCommonDataService.prefilledAi"
         [class.active]="(startAnimations$|async)"
         *ngIf="!isMobile">
      <div [dsTooltip]="'text_undo' | dbText"
           (click)="changeState(builderHistoryService.canUndo, -1)"
           dsTooltipSize="small"
           dsTooltipPosition="bottom"
           dsTooltipColor="black">
        <i class="db-icon db-icon-ds-restore1"
           [class.active]="(builderHistoryService.canUndo|async) && !(_builderSectionsInteractionsService.secondaryPageLoading|async)"></i>
      </div>
      <div [dsTooltip]="'text_redo' | dbText"
           (click)="changeState(builderHistoryService.canRedo, 1)"
           dsTooltipSize="small"
           dsTooltipPosition="bottom"
           dsTooltipColor="black">
        <i class="db-icon db-icon-ds-restore1"
           [class.active]="(builderHistoryService.canRedo|async) && !(_builderSectionsInteractionsService.secondaryPageLoading|async)">
        </i>
      </div>
    </div>
    <!--  <div class="navigation-sitemap-info ml12" *ngIf="!isMobile">
       <i class="db-icon db-icon-ds-sitemap"></i><span class="navigation-sitemap-info-text">{{ companyName }} sitemap</span>
      </div>-->
  </div>
  <div class="builder-header-actions-container" *ngIf="isMobile">
    <button class="ds-btn-purple-blue ds-btn-medium-large tall"
            [ngClass]="{'ds-btn-disabled' : !this.pageLoaded,
            'disable-hover': tourEnum.GENERATION === (builderHistoryService.tourStep|async)}"
            (click)="generateWebsite()">
      <i class="db-icon db-icon-ds-ai-generate"></i>
      <span>{{ 'text_generateYourWebsite' | dbText }}</span>
    </button>
  </div>
</section>
